import { useState } from 'react';
import { SidebarModal } from '../../components/common/Sidebar/Sidebar';
import { Box } from '../../styles/GlobalComponents';
import { SidebarSubtitle, SidebarTitle } from '../../styles/stylesStyled';
import { AddBankAccount } from '../Earnings/Withdraw/AddBankAccount';
import { EditBankAccount } from '../Earnings/Withdraw/EditBankAccount';
import { BankAccount } from './SettingsStyled';

import { useTranslation } from 'react-i18next';
import Spinner from '../../components/common/Spinner';
import { CaptionText, P2, P3 } from '../../styles/FontStyles';
import { Flexed, FloatingButton } from '../../styles/GlobalComponents';
import { color, colors } from '../../styles/GlobalStyles';

import { copyLink, showWallet } from '../../helpers/helperFunctions';

import {
  Icon,
  IconCopy,
  IconEdit,
  IconFlipMeWallet,
  IconSettingsAddWallet,
  IconSettingsRecalculate,
  IconSettingsTrash,
  IconWithdrawWallet
} from '../../styles/Icons';

import ReactTooltip from 'react-tooltip';
import { Desktop, Mobile } from '../../App';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { Button } from '../../components';
import {
  deleteUserWallet,
  reactivateUserWallet
} from '../../slices/wallets-slice';
import { UserWalletModel, UserWalletStatus } from '../../types/wallets-types';

export const PaymentsSettings = () => {
  const { t } = useTranslation('settings');
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);
  const [isOpen4, setIsOpen4] = useState(false);
  const [bank, setBank] = useState<UserWalletModel | null>(null);

  const dispatch = useAppDispatch();
  const { loading } = useAppSelector((state) => state.withdraw);
  const { wallets } = useAppSelector((state) => state.wallets);

  if (loading) return <Spinner fullScreen />;

  const deleteWallet = (account: any) => {
    if (account.status === UserWalletStatus.ACTIVATED && !account.isFlipme) {
      return (
        <Icon
          onClick={(e) => {
            e.stopPropagation();
            setIsOpen3(true);
            setBank(account);
          }}
          color={color.colors.neutral700}
          pointer>
          <IconSettingsTrash />
        </Icon>
      );
    }
  };

  const reactivateWallet = (account: any) => {
    if (account.status === UserWalletStatus.DEACTIVATED && !account.isFlipme) {
      return (
        <Icon
          onClick={(e) => {
            e.stopPropagation();
            dispatch(reactivateUserWallet({ id: account.id }));
          }}
          color={color.colors.neutral700}
          pointer>
          <IconSettingsRecalculate />
        </Icon>
      );
    }
  };

  return (
    <>
      {/* <Box> */}
      {wallets?.map((account, index) => (
        <Box key={index} mb='10' mbSM='10' gray p='5px 10px' pSM='5px 10px'>
          <Flexed rowSM between key={index} p='5px '>
            <Flexed center gap='10px' betweenSM mbSM='5'>
              <Flexed center gap='10px'>
                {account?.isFlipme ? (
                  <Icon ml='7'>
                    <IconFlipMeWallet />
                  </Icon>
                ) : (
                  <Icon
                    color={
                      account.status !== 1
                        ? color.colors.neutral400
                        : color.colors.primary900
                    }>
                    <IconWithdrawWallet />
                  </Icon>
                )}

                <P3
                  color={account.status !== 1 ? color.colors.neutral400 : ''}
                  semiBold>
                  {account.label ?? '---'}
                </P3>
              </Flexed>
              {account.status === UserWalletStatus.ACTIVATED &&
                !account?.isFlipme && (
                  <Icon
                    onClick={() => {
                      setBank(account);
                      setIsOpen4(!isOpen4);
                    }}
                    color={color.colors.neutral900}
                    pointer
                    boxWidth='28px'
                    boxHeight='28px'
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                    <IconEdit />
                  </Icon>
                )}
            </Flexed>
            <Flexed end center gap='10px'>
              {/* <P3 color={account.status !== 1 ? color.colors.neutral400 : ''}>
                <Desktop>{account?.address}</Desktop>
                <Mobile data-tip data-for={'wallet-tooltip-' + index}>
                  {showWallet(account?.address, -20)}
                </Mobile>
              </P3> */}
              <P3
                right
                data-tip
                data-for={'wallet-tooltip-' + index}
                color={account.status !== 1 ? color.colors.neutral400 : ''}
                className='truncated'>
                <div>{account?.address ?? '---'}</div>
              </P3>
              {/* <CaptionText style={{ lineBreak: 'anywhere' }}>
                {' '}
                {account?.address}
              </CaptionText> */}

              {deleteWallet(account)}
              {reactivateWallet(account)}
            </Flexed>
          </Flexed>
          <ReactTooltip
            clickable
            id={'wallet-tooltip-' + index}
            place='top'
            effect='solid'
            backgroundColor='#fff'
            border
            borderColor={color.colors.neutral900}
            delayHide={200}>
            <Flexed style={{ maxWidth: '100%' }} center gap='5px'>
              <CaptionText style={{ lineBreak: 'anywhere' }}>
                {account?.address}
              </CaptionText>
              <Icon
                ml='10'
                color={color.colors.neutral900}
                onClick={() => {
                  copyLink(account?.address, 'Wallet address has been copied');
                }}>
                <IconCopy />
              </Icon>
            </Flexed>
          </ReactTooltip>
        </Box>
      ))}

      <FloatingButton>
        <Button
          maxWidth='200px'
          negative
          onClick={() => setIsOpen2(true)}
          mt='8'>
          <Flexed justifyCenter center>
            {' '}
            <Icon mr='10'>
              {' '}
              <IconSettingsAddWallet />
            </Icon>
            <P3 color={colors.primary900}>Add new wallet</P3>
          </Flexed>
        </Button>
      </FloatingButton>
      {/* </Box> */}

      <SidebarModal
        isOpen={isOpen2}
        setOpen={setIsOpen2}
        title={t('payments.add_new_address')}
        sidebarWidth={'508px'}>
        <AddBankAccount setIsOpen={setIsOpen2} />
      </SidebarModal>

      <SidebarModal
        isOpen={isOpen4}
        setOpen={setIsOpen4}
        title={t('payments.edit_address')}
        sidebarWidth={'508px'}>
        <EditBankAccount setIsOpen4={setIsOpen4} account={bank} />
      </SidebarModal>
      <SidebarModal
        isOpen={isOpen3}
        setOpen={setIsOpen3}
        title={t('payments.delete_wallet_address')}
        sidebarWidth={'508px'}>
        <SidebarTitle>{t('payments.are_you_sure')}</SidebarTitle>
        <SidebarSubtitle>{t('payments.info_about_deletion')}</SidebarSubtitle>

        <BankAccount style={{ width: '100%' }}>
          <Flexed center>
            <Icon color={color.colors.primary900}>
              <IconWithdrawWallet />
            </Icon>
            <P3 semiBold>
              <Desktop>{bank?.address}</Desktop>
              <Mobile>{showWallet(bank?.address || '', -20)}</Mobile>
            </P3>
          </Flexed>
        </BankAccount>

        <Button
          m='20px auto 12px auto'
          onClick={() => {
            if (bank) {
              dispatch(deleteUserWallet({ id: bank?.id }));
              setIsOpen3(false);
            }
          }}>
          {t('payments.delete_address')}
        </Button>
        <Button negative m='0 auto' onClick={() => setIsOpen3(false)}>
          {t('payments.cancel')}
        </Button>
      </SidebarModal>
    </>
  );
};
